export default "__VITE_ASSET__n4p$FMu2__"